export default __webpack_public_path__ + "static/media/img13.8f2e8783.PNG";